export const POSITION_SIDE = {
    BUY: 'BUY',
    SELL: 'SELL',
}

export type TPositionSide = typeof POSITION_SIDE[keyof typeof POSITION_SIDE];

export const POSITION_STATUS = {
    OPEN: 'OPEN',
    CLOSE: 'CLOSE',
}

export type TPositionStatus = typeof POSITION_STATUS[keyof typeof POSITION_STATUS];

export interface IPosition {
    close_price: number,
    close_time: string,
    created_at: string,
    id: number,
    open_price: number,
    open_time: string,
    pl: number,
    position_id: string,
    quantity: number,
    side: TPositionSide,
    status: TPositionStatus,
    symbol: string,
    uid: number,
    updated_at: string,
}
